import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UserState = {
  value: {
    number: number | undefined;
    name: string | undefined;
    branch: string[] | undefined;
  } | null;
};

const initialState: UserState = {
  value: null,
};

export const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      state.value = {
        name: action.payload.name,
        number: action.payload.number,
        branch: action.payload.branch,
      };
    },
  },
});

export const { updateUser } = user.actions;

export default user.reducer;
